import { NgModule } from '@angular/core';

import { HisJobsSharedModule } from './his-jobs-shared.module';

/**
 * The core module for jobs
 */
@NgModule( {
    imports: [
        HisJobsSharedModule
    ],
    declarations: [
    ],
    exports: [
        HisJobsSharedModule
    ]
} )

export class HisJobsCoreModule {

}
